import { render } from "./TopMessage.vue?vue&type=template&id=7d7bc816&scoped=true"
import script from "./TopMessage.vue?vue&type=script&lang=js"
export * from "./TopMessage.vue?vue&type=script&lang=js"

import "./TopMessage.vue?vue&type=style&index=0&id=7d7bc816&lang=less&scoped=true"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-7d7bc816"]])

export default __exports__